<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import {
  authFackMethods
} from "@/state/helpers";

// import Toolbar from "./toolbar";
import Sidepanel from "./sidepanel";
import axios from "axios";
import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Multiselect from "vue-multiselect";
/**
 * Email-read component
 */
export default {
  page: {
    title: "Sent Mails",
    meta: [{ name: "description" }]
  },
  components: {
    Layout,
    PageHeader,
    ckeditor: CKEditor.component,
    // Toolbar,
    Sidepanel,
    Multiselect
  },
  data() {
    return {
      emailId: this.$route.params.id,
      emailData: '',
      showModal: false,
      emailTitle: '',
      editor: ClassicEditor,
      title: "Sent Mails",
      items: [],
      emailDataObj: {},
      users: null,
      isLoading:false,
      noRecord: false,
      sendEmailForm: {
        subject: "",
        description: "<p>Content of the editor.</p>",
        receiver_id: null,
      },
      typeSubmit: false,
    };
  },
  mounted(){
    this.getNotificationsById();
    this.getUsers();
  },
  methods: {
    getNotificationsById(){
      this.isLoading = true;
      this.noRecord = false;
      var token = localStorage.getItem('token');
      var config = {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept': 'application/json'
        }
      };
      if (token) {
        axios.get('admin/notifications/' + this.emailId, config).then(res => {
          this.emailData = res.data.response;
          this.isLoading = false;
          console.log(this.emailData)
          if (!this.emailData.data.length){
            this.noRecord = true;
          }
        }).catch((err) => {
          if (err.response) {
            console.log(err.response)
            if (err.response.status == 404) {
              this.isLoading = false;
              this.noRecord = true;
            }if (err.response.status == 401) {
              this.logout();
            }
          }
        })
      }
      },
    ...authFackMethods,

    replyEmail(emailData){
      this.emailTitle = 'Reply Email';
      this.showModal = true;
      this.sendEmailForm.subject  = emailData.subject;
      this.sendEmailForm.receiver_id  = emailData.receiver;
      this.sendEmailForm.description  = emailData.description;
    },

    forwardEmail(emailData){
      this.emailTitle = 'Forward Email';
      this.showModal = true;
      this.sendEmailForm.subject  = emailData.subject;
      this.sendEmailForm.receiver_id  = null;
      this.sendEmailForm.description  = emailData.description;
    },

    getUsers(){
      axios.get('admin/users?pagination=true&per_page=1000').then(res =>{
        this.users = res.data.response.data;
      })
    },

    sendEmail() {
      this.getUsers();
      let selectedUserIds = [];
      this.sendEmailForm.receiver_id.map(function(value) {
        selectedUserIds.push(value.id);
      });
      this.sendEmailForm.receiver_id = selectedUserIds;
      // this.typesubmit = true;
      // this.$v.$touch();
      // if (!this.$v.$invalid) {
      var token = localStorage.getItem('token');
      var config = {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept': 'application/json'
        }
      };
      if (token) {
        axios.post('admin/notifications', this.sendEmailForm, config)
            .then((res) => {
              if (res.status == '200'){
                Swal.fire({
                  title: "Success!",
                  text:"Email Sent successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.showModal = false;
                this.sendEmailForm = {
                  subject: "",
                  description: "<p>Content of the editor.</p>",
                  receiver_id: null,
                }
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true
                });
              }
            })
      }
      // }

    },

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <!-- Left sidebar -->
        <Sidepanel />
        <!-- End Left sidebar -->

        <!-- Right Sidebar -->

        <div class="email-rightbar mb-3">
          <div class="card">
            <div class="card-body">

              <div v-if="noRecord">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </div>

              <div class="text-center" v-if="isLoading">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </div>
              <div v-if="emailData">
              <div class="media mb-4">
                <div>
                  <img v-if="emailData.sender.avatar !== null"
                      class="d-flex me-3 rounded-circle avatar-sm"
                      :src="emailData.sender.avatar"
                      alt="Avatar"
                  />
                  <img v-else
                       class="d-flex me-3 rounded-circle avatar-sm"
                       src="@/assets/images/no-image.png"
                       alt="Avatar"
                  />
                </div>
                <div class="media-body">
                  <h5 class="font-size-14 mt-1">{{emailData.sender.username}}</h5>
                  <small class="text-muted">{{emailData.sender.email}}</small>
                </div>
              </div>

              <span class="d-inline-block me-2">Dear: </span>
              <p class="d-inline-block receiver" v-for="(receive,index) in emailData.receiver" :key="index">
                <span class="fw-bold" v-if="receive">{{ receive.username }}</span>
                <span v-if="receive && index > 0" class="andSign ms-1 me-1">&</span>
              </p>
              <p><span class="fw-bold">Subject: </span>{{emailData.subject}}</p>
              <p v-html="emailData.description"></p>
              <hr />

              <a href="javascript: void(0);" @click="replyEmail(emailData)" class="btn btn-secondary waves-effect mt-4 me-2">
                <i class="mdi mdi-reply"></i> Reply
              </a>

              <a href="javascript: void(0);" @click="forwardEmail(emailData)" class="btn btn-secondary waves-effect mt-4">
                <i class="mdi mdi-replay"></i> Forward
              </a>

            </div>
            </div>
          </div>
        </div>
        <!-- card -->
      </div>
      <!-- end Col-9 -->

      <b-modal v-model="showModal" :title="emailTitle" centered>
        <form>
          <div class="mb-3">
            <multiselect v-model="sendEmailForm.receiver_id" :options="users"
                         :multiple="true"
                         track-by="username"
                         label="username"
                         placeholder="Select User"
            ></multiselect>
          </div>

          <div class="mb-3">
            <input type="text" v-model="sendEmailForm.subject" class="form-control" placeholder="Subject" />
          </div>
          <div class="mb-3">
            <ckeditor v-model="sendEmailForm.description" :editor="editor"></ckeditor>
          </div>
        </form>

        <template v-slot:modal-footer>
          <b-button variant="secondary" @click="showModal = false">Close</b-button>
          <b-button @click="sendEmail" variant="primary">
            Send
            <i class="fab fa-telegram-plane ms-1"></i>
          </b-button>
        </template>
      </b-modal>

    </div>
  </Layout>
</template>
